import { render, staticRenderFns } from "./ButtonPrimaryAction.vue?vue&type=template&id=842d2c4a&scoped=true&"
import script from "./ButtonPrimaryAction.vue?vue&type=script&lang=js&"
export * from "./ButtonPrimaryAction.vue?vue&type=script&lang=js&"
import style1 from "./ButtonPrimaryAction.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "842d2c4a",
  null
  
)

export default component.exports